// Labels for colors
import {StylingColorSettings} from "../../../../core/models";

export function getColorLabel(key: string): string {
  switch (key) {
    case 'primaryColor':
      return 'Primær farve'
    case 'onPrimary':
      return 'Tekst farve på primær'
    case 'secondaryColor':
      return 'Sekundær farve'
    case 'onSecondary':
      return 'Tekst farve på sekundær'
    case 'primaryContainer':
      return 'Primær container'
    case 'onPrimaryContainer':
      return 'Tekst farve på primær container'
    case 'secondaryContainer':
      return 'Sekundær container'
    case 'onSecondaryContainer':
      return 'Tekst farve på sekundær container'
    case 'warnColor':
      return 'Advarsel farve'
    case 'backgroundColor':
      return 'Baggrundsfarve'
    case 'matCardColor':
      return 'Mat card farve'
    case 'headerTextColor':
      return 'Header tekst farve'
    case 'textColor':
      return 'Body (tekst) farve'
    case 'flatButtonColor':
      return 'Flat button farve'
    case 'onFlatButtonColor':
      return 'Tekst farve på flat button'
    case 'outline':
      return 'Border farve for stroked knap'
    case 'onSecondaryButtonColor':
      return 'Tekst farve for stroked knap'
    case 'selectionColor':
      return 'Valgt tilstand farve (checkbox/radio)'
    case 'onSelectionColor':
      return 'Checkmark farve på valgt tilstand'
    default:
      return 'Farve -';
  }
}
// Explanatory text of how they are used
export function getColorExplanation(key: string): string {
  switch (key) {
    case 'primaryColor':
      return 'Primær brandfarve til handlinger og highlights.';
    case 'onPrimary':
      return 'Tekst/ikoner oven på primær farve med høj kontrast.';
    case 'secondaryColor':
      return 'Sekundær accentfarve til støttehandlinger.';
    case 'onSecondary':
      return 'Tekst/ikoner oven på sekundær farve med høj kontrast.';
    case 'primaryContainer':
      return 'Rolig brandflade; tone af primær farve. Brugt i login side for profil';
    case 'onPrimaryContainer':
      return 'Tekst/ikoner på primær container med korrekt kontrast.';
    case 'secondaryContainer':
      return 'Rolig flade i sekundær tone. Brugt i navigation for ansøgningsskema';
    case 'onSecondaryContainer':
      return 'Tekst/ikoner på sekundær container med korrekt kontrast.';
    case 'warnColor':
      return 'Advarselsfarve til fejl/advarselstilstande.';
    case 'backgroundColor':
      return "App'ens generelle baggrundsfarve.";
    case 'matCardColor':
      return 'Baggrund for Card-komponenter.';
    case 'headerTextColor':
      return 'Tekstfarve til overskrifter på baggrunden.';
    case 'textColor':
      return 'Standard brødtekstfarve på baggrunden.';
    case 'flatButtonColor':
      return 'Baggrundsfarven for primær knapper'
    case 'onFlatButtonColor':
      return 'Tekst farve oven på primære knapper'
    case 'outline':
      return 'Farven omkring sekundær knapper'
    case 'onSecondaryButtonColor':
      return 'Tekst farven ovenpå sekundær knapper'
    case 'selectionColor':
      return 'Fyldfarven på checkbox og radio-knap i valgt tilstand.'
    case 'onSelectionColor':
      return 'Farven på checkmark/ikon oven på den valgte checkbox.'
    default:
      return 'Farverolle (ukendt nøgle).';
  }
}

// Sorting helper
export type Key = keyof StylingColorSettings;


export const COLOR_GROUPS: {
  title: string;
  icon: string;
  paired: boolean;
  colors: { background: Key; text: Key | null }[];
}[] = [
  {
    title: 'Knapper og interaktion',
    icon: 'touch_app',
    paired: true,
    colors: [
      { background: 'primaryColor', text: 'onPrimary' },
      { background: 'secondaryColor', text: 'onSecondary' },
      { background: 'flatButtonColor', text: 'onFlatButtonColor' },
      { background: 'outline', text: 'onSecondaryButtonColor' },
      { background: 'selectionColor', text: 'onSelectionColor' }
    ]
  },
  {
    title: 'Baggrunde og overflader',
    icon: 'layers',
    paired: true,
    colors: [
      { background: 'backgroundColor', text: null },
      { background: 'matCardColor', text: null },
      { background: 'primaryContainer', text: 'onPrimaryContainer' },
      { background: 'secondaryContainer', text: 'onSecondaryContainer' }
    ]
  },
  {
    title: 'Tekst og status',
    icon: 'format_color_text',
    paired: false,
    colors: [
      { background: 'textColor', text: null },
      { background: 'headerTextColor', text: null },
      { background: 'warnColor', text: null }
    ]
  }
];

